/**
 * KPIs API client.
 *
 * Routes through the Vite proxy:
 *   /v1/kpis/* -> cba-api:8004
 *
 * Long-term energy KPIs (self-sufficiency, self-consumption, cumulative
 * savings, asset utilisation) are hosted alongside the CBA service.
 *
 * Note: the axios client in ./client.js unwraps .data automatically
 * via the response interceptor, so mutationFn receives the parsed JSON
 * body directly (not an axios response object).
 */

import client from './client';

export const kpisAPI = {
  /**
   * Compute long-term energy KPIs over a multi-year horizon.
   *
   * @param {object} data - Request body conforming to the long-term KPI schema.
   * @returns {Promise<object>} Parsed KPI result JSON.
   */
  longTerm: (data) => client.post('/v1/kpis/long-term', data),
};
